import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Sync MLS';

  constructor(
    private translate: TranslateService,
  ) {
    this.translate.setDefaultLang('pt');
    this.translate.use(localStorage.getItem('lang') || 'pt')
  }

  ngOnInit() {
    this.loadGtm(environment.GoogleTag);
  }

  loadGtm(id: string) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);
  }

}
